import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { authenticateActions } from "../../store/store";
import { store } from "../../store/store";

const LoginModal = ({ open, onClose, isSuccess, message, status }) => {
  const navigate = useNavigate(); // Initialize navigate for redirection

  // Function to get the appropriate message based on status
  const getMessage = () => {
    if (status) {
      switch (status) {
        case 'success':
          return ''; // You can define a success message if needed
        case 'error':
          return 'Session expired due to inactivity.Are you sure you want to logout?';
        default:
          return '';
      }
    }
    return message || (isSuccess ? 'Successful!' : 'Failed!');
  };
  // Handle button click to redirect to login page
  const handleLoginRedirect = () => {
      onClose(); // Close the modal
      store.dispatch(authenticateActions.logout());
      localStorage.removeItem("refreshToken")
      navigate('/login'); // Redirect to login page
  };
  

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 300,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          textAlign: "center",
          borderRadius: 2,
        }}>
        {/* Success or Error Message */}
        {isSuccess ? (
          <>
            <CheckCircleIcon color="success" sx={{ fontSize: 40 }} />
            <Typography variant="h6" sx={{ mt: 2 }}>
              {getMessage()}
            </Typography>
          </>
        ) : (
          <>
            <ErrorIcon color="error" sx={{ fontSize: 40 }} />
            <Typography variant="h6" sx={{ mt: 2 }}>
              {getMessage()}
            </Typography>
          </>
        )}

        {/* Action Buttons */}
        <Box sx={{ mt: 4, display: "flex", justifyContent: "center", gap: 2 }}>
          <Button
            variant="contained"
            color="error"
            onClick={handleLoginRedirect}>
            Yes
          </Button>
          <Button variant="outlined" color="error" onClick={onClose}>
            No
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default LoginModal;
